import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ variant = "dark", className = "h-9" }) => (
  <Link
    to="/"
    data-testid="cpn-logo-link"
    aria-label="ChannelPartner.Network home"
    className="inline-flex items-center"
  >
    <img
      src="https://customer-assets.emergentagent.com/job_sales-leakage-quiz/artifacts/94oahwa6_ChannelPartner.network%20Logo%20Small.webp"
      alt="ChannelPartner.Network"
      className={`${className} w-auto object-contain ${variant === "dark" ? "" : "invert brightness-0 saturate-0"}`}
    />
  </Link>
);
